
const state = {
  agency_id: undefined,
  id: null,
  identity_code: '',
  provider_id: undefined,
  provider_price_list_id: undefined,
  service_id: undefined,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'provider_id' },
  { key: 'service_id' },
]

export default state
